import React from 'react';
import CCMRSSyle from '../style';
import RoundScreen from '../../../components/roundScreen';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen/index';
import CategoryScreenBackground from '../../../images/ComponentImages/categoryScreenBackground.png';

export default function Page06({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen
				titles={['Day 1', 'Back C.C.M.R’S']}
				texts={['Yes your workout starts now']}
				BGImage={CategoryScreenBackground}
			/>
			<RoundScreen
				title='Run 6 Rounds'
				isNumbered={true}
				rounds={[
					[
						{
							header: 'Type',
							value: 'Alpha',
						},
						{
							header: 'C.C.M.R’s',
							value: 'BENT-OVER ROWS (BB)',
						},
						{
							header: 'REPS/Min',
							value: '6-8',
						},
						{
							header: 'WEIGHT LEVE',
							value: 'Mild-->Heavy',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'UNDER-HAND PULLUPS',
						},
						{
							header: 'REPS/Min',
							value: '10',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'BodyWeight',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'KETTLEBELL SHRUGS',
						},
						{
							header: 'REPS/Min',
							value: '15-20',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Heavy',
						},
					],
				]}
			/>
			<p style={style.takeABreakTextStyle()}>Take a 1 - 2 minute break</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
